import getArgumentRegex from './getArgumentRegex';

const replaceChildrenKeys = (children, key, matchedKey) => {
  return children.map((n) => {
    const obj = {
      ...n,
      key: typeof n.key === 'string' ? n.key.replace(key, matchedKey) : n.key
    };
    if (n.children) {
      obj.children = replaceChildrenKeys(n.children, key, matchedKey);
    }
    return obj;
  });
};

const nestWorkflowArguments = (args, values = {}, parentKey = '') => {
  if (!Array.isArray(args)) return [];
  return args
    .filter((arg) => {
      const keyToMatch = parentKey ? `${parentKey}.` : '';
      const modifiedKey = keyToMatch.replaceAll(/\[\d+\]/g, '[]');

      if (arg?.dependencies?.length) {
        const dependenciesSatisfied = arg.dependencies.every((depId) => {
          const depDef = args?.find((a) => a.id === depId);
          const argKey = depDef?.key;
          const depValue = values?.[argKey];
          return depValue !== undefined && depValue !== null && depValue !== '';
        });
        if (!dependenciesSatisfied) return false;
      }
      return typeof arg?.key === 'string' && arg.key.startsWith(modifiedKey) && arg.key !== parentKey;
    })
    .map((arg) => {
      const cleanParentKey = parentKey.replaceAll(/\[\d+\]/g, '[]');
      const argKey = typeof arg.key === 'string' ? arg.key : String(arg.key ?? '');
      const modifiedKey = argKey.replace(cleanParentKey, parentKey);

      if (arg.dataType === 'object') {
        return {
          ...arg,
          children: nestWorkflowArguments(args, values, modifiedKey)
        };
      }

      if (values?.[modifiedKey]?.type === 'arrayMap') {
        return {
          ...arg,
          children: nestWorkflowArguments(args, values, modifiedKey),
          arrayMap: true
        };
      }
      if (arg.dataType === 'array') {
        let arrayChildren = [];

        const regex = getArgumentRegex(argKey, values);
        const processedIndices = new Set();

        Object.keys(values)
          .filter((n) => n.startsWith(parentKey))
          .forEach((key) => {
            const match = key.match(regex);

            if (match) {
              const matchedKey = match[0];
              if (!processedIndices.has(matchedKey)) {
                processedIndices.add(matchedKey);
                let newChildren = nestWorkflowArguments(args, values, matchedKey);

                newChildren = replaceChildrenKeys(newChildren, argKey, matchedKey);

                arrayChildren.push({
                  ...arg,
                  key: matchedKey,
                  dataType: 'array',
                  children: newChildren,
                  row: true
                });
              }
            }
          });

        arrayChildren = arrayChildren.map((n, idx) => ({
          ...n,
          name: `Row ${idx + 1}`
        }));

        return {
          ...arg,
          children: arrayChildren
        };
      }
      return arg;
    })
    .filter((arg) => typeof arg.key === 'string' && (parentKey === '' ? arg.key.split('.').length === 1 : arg.key.split('.').length === parentKey.split('.').length + 1))
    .sort((a, b) => {
      const locationOrder = ['param', 'query', 'body'];
      return locationOrder.indexOf(a.location) - locationOrder.indexOf(b.location);
    });
};

export default nestWorkflowArguments;
